import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    margin: '16px 16px 16px 11px',
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
  },
  cardWrapper: {
    width: 'calc(50% - 8px)',
    '&:last-child': {
      width: '100%',
    },
  },
  card: {
    width: '100%',
    alignSelf: 'center',
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '8px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    padding: '16px 24px',
    backgroundColor: 'white',
    boxSizing: 'border-box',
  },
  accordion: {
    width: '100%',
    marginBottom: '8px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    padding: '0',
    backgroundColor: 'white',
    alignSelf: 'center',
    whiteSpace: 'pre-wrap',
    '&:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root': {
      padding: '4px 16px 4px 24px',
    },
    '& .MuiAccordionDetails-root': {
      paddingLeft: '24px',
    },
    '& .MuiAccordionSummary-content': {
      fontWeight: 700,
    },
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 700,
    marginBottom: '12px',
  },
  label: {
    fontWeight: 700,
    marginRight: '8px',
    width: '25%',
  },
  ticketItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
  },
  ticketItem: {
    display: 'flex',
  },
  audio: {
    alignItems: 'center',
    padding: '8px 34px 8px 24px',
    '& audio': {
      height: '40px',
      width: '75%',
    },
  },
}));

export default useStyles;
